import React from 'react';
import { ArrowRight, Wheat, Award, Truck } from 'lucide-react';
import { useLeadCapture } from '../hooks/useLeadCapture';
import LeadCaptureModal from './LeadCaptureModal';

const Hero = () => {
  const { isModalOpen, selectedProduct, openModal, closeModal } = useLeadCapture();

  const scrollToProducts = () => {
    const element = document.getElementById('products');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleGetQuote = () => {
    openModal('General Inquiry');
  };

  return (
    <>
      <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20 sm:pt-24 md:pt-32">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://images.pexels.com/photos/422218/pexels-photo-422218.jpeg"
            alt="Cattle grazing in green fields"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16 md:py-20 text-center text-white">
          <div className="space-y-6 sm:space-y-8">
            <div className="space-y-3 sm:space-y-4">
              <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold leading-tight">
                Nourishing India's
                <span className="block text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-amber-500">
                  Dairy Future
                </span>
              </h1>
              <p className="text-sm sm:text-base md:text-xl lg:text-2xl text-gray-200 max-w-3xl mx-auto leading-relaxed px-2">
                Premium cotton seed cake and cattle feed manufacturer in Indore.
                Trusted by thousands of dairy farmers across India since 1995.
              </p>
            </div>

            {/* Key Stats */}
            <div className="flex flex-wrap justify-center gap-2 sm:gap-4 md:gap-8 py-6 sm:py-8 px-2">
              <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-3 sm:px-4 md:px-6 py-2 sm:py-3">
                <Award className="text-yellow-400 flex-shrink-0" size={16} />
                <span className="font-semibold text-xs sm:text-sm md:text-base">25+ Years</span>
              </div>
              <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-3 sm:px-4 md:px-6 py-2 sm:py-3">
                <Wheat className="text-green-400 flex-shrink-0" size={16} />
                <span className="font-semibold text-xs sm:text-sm md:text-base">Premium Quality</span>
              </div>
              <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-3 sm:px-4 md:px-6 py-2 sm:py-3">
                <Truck className="text-blue-400 flex-shrink-0" size={16} />
                <span className="font-semibold text-xs sm:text-sm md:text-base">Pan India</span>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center pt-6 sm:pt-8 px-2">
              <button
                onClick={handleGetQuote}
                className="group bg-gradient-to-r from-amber-500 to-yellow-500 text-black px-5 sm:px-6 md:px-8 py-2.5 sm:py-3 md:py-4 rounded-full font-bold text-sm sm:text-base md:text-lg transition-all duration-200 hover:from-amber-400 hover:to-yellow-400 hover:scale-105 shadow-lg hover:shadow-xl flex items-center space-x-2 w-full sm:w-auto justify-center"
              >
                <span>Get Quote Now</span>
                <ArrowRight className="group-hover:translate-x-1 transition-transform duration-200" size={18} />
              </button>
              <button
                onClick={scrollToProducts}
                className="group border-2 border-white text-white px-5 sm:px-6 md:px-8 py-2.5 sm:py-3 md:py-4 rounded-full font-bold text-sm sm:text-base md:text-lg transition-all duration-200 hover:bg-white hover:text-gray-900 flex items-center space-x-2 w-full sm:w-auto justify-center"
              >
                <span>View Products</span>
                <ArrowRight className="group-hover:translate-x-1 transition-transform duration-200" size={18} />
              </button>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white">
          <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
            <div className="w-1 h-3 bg-white rounded-full mt-2"></div>
          </div>
        </div>
      </section>

      {/* Lead Capture Modal */}
      <LeadCaptureModal
        isOpen={isModalOpen}
        onClose={closeModal}
        productName={selectedProduct}
      />
    </>
  );
};

export default Hero;